import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Button,
  Checkbox,
  Table,
  TableRow,
  TableCell,
} from "@mui/material";
import React from "react";
import { useMessages } from "./MessagesContext";
import { MessageModel } from "./utils";

const MessageFilter = () => {
  const { filters, filterValues, setFilters, setSelectedMessage,setMessage } =
    useMessages();

//   const handleFilterChange = (e) => {
//     const name = e.target.name.toLowerCase();
//     const value = e.target.value;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

  const handleFilterChange = (e) => {
    const name = e.target.name;
    const checked = e.target.checked;
    
    // console.log("name checked"+name,checked)
    setFilters((prev) => ({ ...prev, [name]: checked }));
  };

  if (
    filterValues.activeOnly !== null &&
    filterValues.includeIncidentMessages !== null 
  )
    return (
      <Box>
        <Typography variant="h5" sx={{ mb: 1, textAlign: "center", mt: 2 }}>
          Manage Messages
        </Typography>
       
                   <Box>
                    <Table size="small">
                        <TableRow>
                            <TableCell align="center">
                                <Typography>Active Only</Typography>
                                <Checkbox label="Active Only" name="activeOnly" checked={filters.activeOnly} onChange={handleFilterChange}/>
                            </TableCell>
                            
                            <TableCell align="center">
                                <Typography>Include Incident Messages</Typography>
                                <Checkbox label="IncludeIncidentMessages" name="includeIncidentMessages" checked={filters.includeIncidentMessages} onChange={handleFilterChange}/>
                            </TableCell>
                            <TableCell align="Center">
                            {/* <Typography variant='h5'sx={{ mb: 1, textAlign: "center", mt: 2 }}> Messages </Typography> */}
                            <Button variant="contained" onClick={(e) => setMessage(MessageModel)} > Create New Message </Button>
                            </TableCell>
                        </TableRow>
                    </Table>
                </Box>

                
                
            
    </Box>        
            
    );
};

export default MessageFilter;
